import React,  {Component} from 'react';
import Card from '../card';
import {connect} from 'react-redux';
import {withDataPhone} from '../hoc';
import {phoneLoaded , addLoading , addError} from '../../actions';
import Spinner from '../spinner';
import Error from '../error';
import './shop.css';


const Shop=({phones})=>{

    let list=phones.map((item)=>{
        return(
            <Card {...item} key={item.id} />
        );
    });
    return(
        <div className="shop-content">
            <div className="row">
                {list}
            </div>
        </div>      
    );
}


class ShopContainer extends Component{


    componentWillMount(){
        this.props.fetchPhones();
    }


    render=()=>{
        let {phones , loading , error}=this.props;

        if(error){
            return (<Error/>);
        }
        if(loading){
            return (<Spinner/>);
        }
        
        return (
            <Shop phones={phones}/>
        );
    }
}


const mapStateToProps=({phones , loading , error})=>{
    return{
        phones , loading , error
    }
}
const mapDispatchToProps=(dispatch , ownProperty)=>{
    let {phoneservice}=ownProperty;
    return{
        fetchPhones:()=>{
            dispatch(addLoading(true));

            phoneservice.getList()
            .then(data=>{
                dispatch(phoneLoaded(data));
            })
            .catch((err)=>{
                dispatch(addError(err));
            });
        }
    }
    
}

export default withDataPhone()(connect(mapStateToProps , mapDispatchToProps)(ShopContainer));